<footer *ngIf="!isTreasurePickRoute()" class="footer-auth" [class.is-dashboard]="isDashboardRoute()">
  <div class="footer-auth-main">
    <div class="footer-auth-logo-clip">
      <img
        src="/mainLogo.webp"
        alt="Real Winning Logo"
        class="footer-auth-logo"
      />
    </div>
    <div class="footer-auth-social">
      <a
        href="https://www.facebook.com/Luckycrest.game"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
        class="footer-auth-icon"
      >
        <i class="fab fa-facebook-f"></i>
      </a>
    </div>
  </div>
  <p class="footer-auth-rights">
    All Rights Reserved &copy; Luckycrest
  </p>
</footer>
<!-- <div *ngIf="!isDashboardRoute() || !isScreenWidthLessThan800()" id="footer"
  class="relative bottom-0 left-0 right-0 bg-[var(--landing-back)] p-4 md:p-8" style="padding: 2rem 2rem 1.5rem">
  <div class="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center justify-between ng-star-inserted">
    <div class="flex items-center flex-wrap first-letter justify-between">
      <div class="flex gap-2 items-center">
        <div>
          <img loading="lazy" src="/cmax-assets/high_rollers_logo.png" alt="logo" class="w-16 sm:w-20 md:w-24 lg:w-auto" />
        </div>
        <span class="text-xl sm:text-2xl md:text-3xl text-white">Luckycrest</span>
      </div>
    </div>

    <div class="flex justify-center items-center">
      <p style="color: #9196a5" class="text-center">
        All Rights Reserved © Luckycrest.
      </p>
    </div>
  </div>
</div> -->

<!-- <div *ngIf="!isDashboardRoute() || !isScreenWidthLessThan800()" id="footer"
  class="relative bottom-0 left-0 right-0 bg-gray-900 text-white pt-8 pb-6">
  <div class="container mx-auto flex flex-wrap items-center justify-between px-6 flex-col sm:flex-row">
    <div class="flex items-center gap-3">
      <img loading="lazy" src="/cmax-assets/high_rollers_logo.png" alt="Luckycrest Logo" class="h-10 w-12" />
      <span class="text-xl font-semibold mt-1">HighRollers</span>
    </div>

    <div class="flex flex-col mt-4 sm:mt-0 items-center justify-center"> -->
<!-- <a
        href="#"
        aria-label="Facebook"
        class="text-gray-400 hover:text-white transition"
      >
        <i class="fab fa-facebook-f"></i>
      </a> -->
<!-- <a (click)="changeRoute('/Terms&Condition')" class="text-gray-400 hover:text-white transition cursor-pointer">
        <p>Terms&Conditions</p>
      </a>
      <a (click)="changeRoute('/Refund&Cancellation')" class="text-gray-400 hover:text-white transition cursor-pointer">
        <p>Refund&Cancellation Policy</p>
      </a> -->
<!-- </div>
  </div> -->

<!-- Footer Line -->
<!-- <hr class="border-gray-600 my-4" />

  <div class="container mx-auto text-center text-sm text-gray-500">
    © HighRollers. All rights reserved. Unauthorized use prohibited.
  </div>
</div> -->

<!-- navbar on  small screens  -->

<nav
  *ngIf="
    isDashboardRoute() && isScreenWidthLessThan800() && !isTreasurePickRoute()
  "
  class="mobile-bottom-nav"
>
  <!-- Home -->
  <a
    routerLink="/dashboard/home"
    routerLinkActive="active-tab"
    #rlaHome="routerLinkActive"
    (click)="changeRoute('/dashboard/home')"
    [class.active-tab]="rlaHome.isActive && !isChatVisible"
    class="nav-item"
  >
    <div class="icon-wrapper">
      <img loading="lazy" src="icons/home.svg" class="nav-icon" alt="" />
    </div>
    <span>Home</span>
  </a>

  <!-- Wallet -->
  <a
    routerLink="/dashboard/wallet"
    routerLinkActive="active-tab"
    #rlaWallet="routerLinkActive"
    (click)="changeRoute('/dashboard/wallet')"
    [class.active-tab]="rlaWallet.isActive && !isChatVisible"
    class="nav-item"
  >
    <div class="icon-wrapper">
      <img loading="lazy" src="icons/wallet.svg" class="nav-icon" alt="" />
    </div>
    <span>Wallet</span>
  </a>

  <!-- Game Acc -->
  <a
    routerLink="/dashboard/account"
    routerLinkActive="active-tab"
    #rlaAccount="routerLinkActive"
    (click)="changeRoute('/dashboard/account')"
    [class.active-tab]="rlaAccount.isActive && !isChatVisible"
    class="nav-item"
  >
    <div class="icon-wrapper">
      <img loading="lazy" src="icons/game-account.svg" class="nav-icon" alt="" />
    </div>
    <span>Game Acc</span>
  </a>

  <!-- Chat -->
  <a
    (click)="showChatComponent()"
    [class.active-tab]="isChatVisible"
    class="nav-item relative"
  >
    <!-- Notification Badge -->
    <div
      *ngIf="unreadCounts > 0"
      class="nav-badge"
    >
      {{ unreadCounts > 99 ? "99+" : unreadCounts }}
    </div>
    <div class="icon-wrapper">
      <img loading="lazy" src="icons/chat.svg" class="nav-icon" alt="" />
    </div>
    <span>Chat</span>
  </a>
</nav>

<!-- <nav
  *ngIf="
    isDashboardRoute() && isScreenWidthLessThan800() && !isTreasurePickRoute()
  "
  class="fixed -bottom-0 left-0 right-0 h-20 custom-bg flex items-center justify-around px-4 mt-4 z-[999] bg-[#13192e] border-t-2 border-gray-500">
  <a routerLink="/dashboard/home" routerLinkActive="active-tab"
    class="flex flex-col items-center justify-center cursor-pointer text-gray-300 hover:text-white transition-colors">
    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
    </svg>
    <span class="text-xs mt-1">Home</span>
  </a>

  <a routerLinkActive="active-tab" #rlaWallet="routerLinkActive" (click)="changeRoute('/dashboard/wallet')"
    routerLink="/dashboard/wallet" [routerLinkActiveOptions]="{ exact: true }"
    [class.active-tab]="rlaWallet.isActive && !isChatVisible"
    class="flex flex-col items-center justify-center cursor-pointer text-gray-300 hover:text-white transition-colors">
    <fa-icon [icon]="Wallet" class="wallet-icon"></fa-icon>
    <span class="text-xs mt-1">Wallet</span>
  </a>

  <a routerLinkActive="active-tab" #rlaSpinner="routerLinkActive" (click)="changeRoute('/dashboard/spinner')"
    routerLink="/dashboard/spinner" [routerLinkActiveOptions]="{ exact: true }"
    [class.active-tab]="rlaSpinner.isActive && !isChatVisible"
    class="flex flex-col items-center justify-center cursor-pointer text-gray-300 hover:text-white transition-colors">
    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
    </svg>
    <span class="text-xs mt-1">Spin</span>
  </a>

  <a routerLinkActive="active-tab" (click)="changeRoute('/dashboard/lottery')" routerLink="/dashboard/lottery"
    #rlaLottery="routerLinkActive" [routerLinkActiveOptions]="{ exact: true }"
    [class.active-tab]="rlaLottery.isActive && !isChatVisible"
    class="flex flex-col items-center justify-center cursor-pointer text-gray-300 hover:text-white transition-colors">
    <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
      stroke-linejoin="round" viewBox="0 0 24 24">
      <path d="M2 6c2 0 2-2 4-2s2 2 4 2 2-2 4-2 2 2 4 2 2-2 4-2 2 2 4-2v12c-2 0-2 2-4 2s-2-2-4-2-2 2-4 2-2-2-4-2-2 2-4 2V6z" />
      <circle cx="7" cy="12" r="1.5" />
      <circle cx="12" cy="12" r="1.5" />
      <circle cx="17" cy="12" r="1.5" />
      <path d="M12 5l1 2 2 .5-1.5 1.5.5 2-2-1-2 1 .5-2L9 7.5l2-.5z" />
    </svg>
    <span class="text-xs mt-1">Lottery</span>
  </a>

  <a routerLinkActive="active-tab" #rlaScratchCards="routerLinkActive" (click)="changeRoute('/dashboard/scratch')"
    routerLink="/dashboard/scratch" [routerLinkActiveOptions]="{ exact: true }"
    [class.active-tab]="rlaScratchCards.isActive && !isChatVisible"
    class="flex flex-col items-center justify-center cursor-pointer text-gray-300 hover:text-white transition-colors"
  >
    
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      viewBox="0 0 24 24"
      class="w-5 h-5"
    >
      
      <rect x="3" y="3" width="18" height="14" rx="2" ry="2"></rect>
      <line x1="3" y1="9" x2="21" y2="9"></line>
      <path d="M8 15h1m2 0h1m2 0h1"></path>
    </svg>

    <span class="text-xs mt-1">Scratch</span>
  </a>


  <a (click)="showChatComponent()" [class.active-tab]="isChatVisible"
    class="flex flex-col items-center justify-center cursor-pointer text-gray-300 hover:text-white transition-colors">
    <div *ngIf="unreadCounts > 0"
      class="absolute top-2 right-2 w-6 h-6 flex items-center rounded-full text-black justify-center animate-pulse bg-[#A6EFEF]">
      {{ unreadCounts > 99 ? "99+" : unreadCounts }}
    </div>
    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z">
      </path>
    </svg>
    <span class="text-xs mt-1">Chat</span>
  </a>
</nav> -->
